<template>
  <div
    class="column padding-top-xs padding-bottom-md hero-icon-grid"
    :style="gridStyles"
    @click="navigateToSearchResult"
  >
    <div
      v-for="row in gridConfig.numRows"
      :key="`${position}-row-${row}`"
      :style="rowStyles(row)"
    >
      <div
        v-for="col in gridConfig.numCols"
        :key="`${position}-icon-${row}-${col}`"
      >
        <transition
          enter-active-class="animate__animated animate__fastest animate__fadeIn"
          leave-active-class="animate__animated animate__fastest animate__fadeOut"
          mode="out-in"
        >
          <i
            :key="`${position}-${row}-${col}-${iconClassMatrix[row - 1][col - 1].join('-')}`"
            :class="iconClassMatrix[row - 1][col - 1]"
            :style="iconStyles(row, col)"
            aria-hidden="true"
          />
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'HeroIconGrid',

    props: {
      iconClassMatrix: {
        type: Array,
        required: true,
        validator: (matrix) => Array.isArray(matrix) && matrix.every((row) => Array.isArray(row))
      },
      primaryColor: {
        type: String,
        required: true
      },
      colorTransition: {
        type: String,
        required: false
      },
      gridConfig: {
        type: Object,
        required: true,
        validator: (cfg) => typeof cfg === 'object' && typeof cfg.numRows === 'number' && typeof cfg.numCols === 'number'
      },
      position: {
        type: String,
        required: true,
        validator: (value) => ['left', 'right'].includes(value)
      },
      currentFamily: {
        type: String,
        required: true
      },
      currentStyle: {
        type: String,
        required: true
      },
      currentPackName: {
        type: String,
        required: true
      }
    },

    computed: {
      gridStyles() {
        return {
          gap: this.gridConfig.gap,
          fontSize: this.gridConfig.fontSize,
          alignItems: this.gridConfig.alignment,
          cursor: 'pointer'
        }
      },
      gridMismatch() {
        return (
          this.iconClassMatrix.length !== this.gridConfig.numRows || (this.iconClassMatrix[0] && this.iconClassMatrix[0].length !== this.gridConfig.numCols)
        )
      }
    },

    watch: {
      gridMismatch(val) {
        if (val) {
          // eslint-disable-next-line no-console
          console.warn('IconGrid: iconClassMatrix dimensions do not match gridConfig. This may cause rendering issues.')
        }
      }
    },

    methods: {
      rowStyles(row) {
        const marginProperty = this.gridConfig.marginDirection === 'right' ? 'marginRight' : 'marginLeft'
        return {
          display: 'flex',
          gap: this.gridConfig.iconGap,
          [marginProperty]: row % 2 === 0 ? this.gridConfig.marginOffset : '0'
        }
      },

      iconStyles(row, col) {
        const rotation = this.getRotationDeg(row, col)
        return {
          transform: rotation,
          color: this.primaryColor,
          transition: this.colorTransition,
          fontSize: this.gridConfig.fontSize,
          lineHeight: '1',
          verticalAlign: 'middle'
        }
      },

      getRotationDeg(rowIndex, colIndex) {
        const angle = this.gridConfig.rotationAngle || 15
        return (colIndex + rowIndex) % 2 === 0 ? `rotate(${angle}deg)` : `rotate(-${angle}deg)`
      },

      navigateToSearchResult() {
        this.$router.push(
          this.$search({
            iconPacks: [this.currentPackName],
            styles: [this.currentStyle]
          })
        )
        this.$posthog.capture('home_hero:icon_grid_click', {
          pack: this.currentPackName,
          style: this.currentStyle
        })
      }
    }
  }
</script>
